import { API } from '../../../../config';
import { errorHandler } from '../../auth/errorAction';

export const unmountListJobIndustries = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_JOB_INDUSTRIES'})
}

export const unmountDetailJobIndustries = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DETAIL_JOB_INDUSTRIES'})
}

export const unmountMasterJobIndustries = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_MASTER_JOB_INDUSTRIES'})
}

export const listJobIndustries = (meta) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_JOB_INDUSTRIES' })
  return API.GET('/job-industry/list', meta).then((response) => {
    dispatch({
      type: 'LOAD_DATA_JOB_INDUSTRIES_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: response.meta.page,
          total: response.meta.total,
          perpage: response.meta.perpage
        }
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_JOB_INDUSTRIES_FAILED' }), 
    ))
  })
}

export const detailJobIndustry = (id, successCB, failedCB) => async dispatch => {
  await dispatch({ type: 'LOAD_DETAIL_JOB_INDUSTRIES' })
  const params = {
    'id': id
  }
  API.GET('/job-industry/getById', params).then((response) => {
    dispatch({ 
      type: 'LOAD_DETAIL_JOB_INDUSTRIES_SUCCESS', 
      payload : { 
        data: response.data 
      } 
    })
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(
        err, 
        dispatch({ type: 'LOAD_DETAIL_JOB_INDUSTRIES_FAILED' }), 
      ))
    )
  })
}

export const masterJobIndustries = (successCB, failedCB) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_MASTER_JOB_INDUSTRIES' })
  return API.GET('/job-industry/index').then((response) => {
    dispatch({
      type: 'LOAD_DATA_MASTER_JOB_INDUSTRIES_SUCCESS', 
      payload: { data: response.data }
    })
    return successCB && successCB(response.data)
  }).catch((err) => {
    failedCB && failedCB()
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_MASTER_JOB_INDUSTRIES_FAILED' }), 
    ))
  })
}

export const createJobIndustry = (value, successCB, failedCB) => () => {
  API.POST_FORM_DATA('/job-industry/add', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const editJobIndustry = (value, successCB, failedCB) => () => {
  API.POST_FORM_DATA('/job-industry/update', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const enableJobIndustry = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/job-industry/enable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const disableJobIndustry = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/job-industry/disable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}